export default __webpack_public_path__ + "static/media/plan2.9ead1445.png";